<div class="pageheader pageheaderlogin pageheader-login">
    <header id="header">
        <div id="login_gestionAR">GestiónAR PRODUCTOR</div>
        <div class="header_bg_green inicio_bg"></div>
        <div class="header_bg inicio_bg"></div>
        <a href="{{Bayer}}" title="Homepage" class="logo logo_login">
            <img loading="lazy" decoding="async" src="{{Etiquetas.Home.HeaderImage1}}" aria-label="Bayer">
        </a>
        <div class="logo_gestionar_login logo_gestionar_login_2">
            <img loading="lazy" decoding="async" src="{{Etiquetas.Home.HeaderImage2}}" aria-label="Bayer">
        </div>
    </header>
</div>